/* eslint-disable react/jsx-no-target-blank */
import {useIntl} from 'react-intl'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'

const SidebarMenuMain = () => {
  const intl = useIntl()

  return (
    <>
      <SidebarMenuItem
        to="/dashboard"
        icon="element-11"
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon="bi-app-indicator"
      />
      {/* <SidebarMenuItem to="/profile/overview" icon="home" title="Profile" /> */}
      <SidebarMenuItemWithSub
        to="/users"
        title="Users Management"
        fontIcon="bi-archive"
        icon="element-plus"
      >
        <SidebarMenuItem to="users/driver" title="Driver" hasBullet={true} />
        <SidebarMenuItem to="users/student" title="Student" hasBullet={true} />
        <SidebarMenuItem to="users/staff" title="Staff" hasBullet={true} />

        {/* <SidebarMenuItem to="users/upload-student" title="Student Upload" hasBullet={true} /> */}
        {/* <SidebarMenuItem to="users/upload-nfc" title="NFC Upload" hasBullet={true} /> */}
        <SidebarMenuItem to="users/guardians" title="Guardians" hasBullet={true} />
        <SidebarMenuItem to="users/conductors" title="Bus Attendees" hasBullet={true} />
        <SidebarMenuItem to="users/security" title="Security" hasBullet={true} />
        <SidebarMenuItem to="users/team-leader" title="Team Leader" hasBullet={true} />
        <SidebarMenuItem to="users/transport-admin" title="Transport Admin User" hasBullet={true} />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to="school-management"
        title="School Management"
        fontIcon="bi-archive"
        icon="element-plus"
      >
        <SidebarMenuItem to="school-management/shift" title="Shift" hasBullet={true} />

        <SidebarMenuItem to="school-management/class" title="Class" hasBullet={true} />
        <SidebarMenuItem to="school-management/division" title="Division" hasBullet={true} />
        <SidebarMenuItem to="school-management/bus" title="Bus" hasBullet={true} />
        <SidebarMenuItem to="school-management/all-bus-brand" title="Bus Brand" hasBullet={true} />

        <SidebarMenuItem to="school-management/routes" title="Routes" hasBullet={true} />
        <SidebarMenuItem to="school-management/holidays" title="Holidays" hasBullet={true} />
        <SidebarMenuItem to="school-management/banner" title="Banner" hasBullet={true} />
      </SidebarMenuItemWithSub>

      <SidebarMenuItemWithSub
        to="trip"
        title="Trip Details"
        fontIcon="bi-archive"
        icon="element-plus"
      >
        <SidebarMenuItem
          to="/trip/live-trip"
          // icon="delivery-geolocation"
          title="Live Trip"
          hasBullet={true}
        />
        <SidebarMenuItem to="/trip/all-trip-numbers" title="Trip Numbers" hasBullet={true} />
        <SidebarMenuItem to="/trip/all-trip-list" title="Daily Trip List" hasBullet={true} />
        <SidebarMenuItem to="/stay/all-stay-list" title="Stay Back Trip List" hasBullet={true} />
        <SidebarMenuItem to="/trip/trip-history" title="Trip History" hasBullet={true} />
        {/* <SidebarMenuItem to="/trip/upload" title="Trip Upload" hasBullet={true} /> */}
      </SidebarMenuItemWithSub>

      <SidebarMenuItem to="/event-calendar" icon="element-plus" title="Event Calendar" />
      <SidebarMenuItem to="/broadcast" icon="element-plus" title="Broadcast" />
      <SidebarMenuItemWithSub to="report" title="Reports" fontIcon="bi-archive" icon="element-plus">
        <SidebarMenuItem to="/inspection-report" title="Inspection Report" hasBullet={true} />
        <SidebarMenuItem to="/fleet-report" title="Fleet Report" hasBullet={true} />
        <SidebarMenuItem
          to="/driver-license-report"
          title="Driver License Status Report"
          hasBullet={true}
        />
        <SidebarMenuItem
          to="/student-attendance-report"
          title="Student Attendance Report"
          hasBullet={true}
        />
         <SidebarMenuItem
          to="/route-report"
          title="Route Chart Report"
          hasBullet={true}
        />
        <SidebarMenuItem
          to="/driver-login-report"
          title="Driver Login Report"
          hasBullet={true}
        />
        <SidebarMenuItem
          to="/vehicle-movement-report"
          title="Daily Vehicle Movement Report"
          hasBullet={true}
        />
        <SidebarMenuItem
          to="/trip-not-started-report"
          title="Trip Not Started Report"
          hasBullet={true}
        />
      </SidebarMenuItemWithSub>
    </>
  )
}

export {SidebarMenuMain}
